import { render, staticRenderFns } from "./FoundationsPlan.vue?vue&type=template&id=acab4b72&"
import script from "./FoundationsPlan.vue?vue&type=script&lang=js&"
export * from "./FoundationsPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports